import React from "react";
import { Heart, Palette, Wheat } from "lucide-react";
import { cn } from "@/lib/utils";
const differences = [{
  title: "Specialist Expertise",
  description: "Our team brings years of focused experience in uPVC and EPDM roofing, ensuring every installation meets the highest architectural and industry standards.",
  icon: Palette
}, {
  title: "Premium Materials",
  description: "We source only the finest weather-resistant materials designed to protect your home while providing a sleek, modern finish that lasts for decades.",
  icon: Wheat
}, {
  title: "Absolute Trust",
  description: "Built on transparency and a stellar North East reputation, we provide comprehensive warranties that guarantee peace of mind for every homeowner.",
  icon: Heart
}];
export default function TheDilzDifference() {
  return <section data-section-id="85560" id="why-choose-five-star" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-6xl font-serif text-primary mb-6 tracking-tight font-bold">
            Why Choose Five Star
          </h2>
          <p className="font-sans font-normal text-muted-foreground max-w-2xl mx-auto text-lg md:text-xl">
            Delivering elite roofline solutions across the North East with a commitment to durability, precision, and high-end aesthetics.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-16 md:gap-y-0">
          {differences.map((item, i) => <div key={i} data-index={i} className={cn("flex flex-col items-center text-center px-6 lg:px-12 relative", i === 1 ? "md:border-x md:border-primary/10" : "", i !== 2 ? "border-b border-primary/10 pb-16 md:border-b-0 md:pb-0" : "")}>
              <div className="relative flex items-center justify-center w-24 h-24 mb-10">
                {}
                <div className="absolute inset-0 bg-primary/10 blur-3xl rounded-full"></div>
                <item.icon className="relative w-14 h-14 text-primary drop-shadow-[0_0_12px_rgba(var(--primary),0.3)]" strokeWidth={1.25} />
              </div>
              
              <h3 className="text-2xl md:text-3xl font-serif mb-6 text-foreground font-bold tracking-tight">
                {item.title}
              </h3>
              
              <p className="font-sans font-normal leading-relaxed text-muted-foreground text-base md:text-lg">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}